<template>
  <div class="center-panel">
    <StatsCard />
    <div class="map-card">
      <MapDrillDown/>
    </div>
  </div>
</template>

<script>
import StatsCard from './StatsCard.vue'
import MapDrillDown from '@/views/ChinaMapData/components/body/center/MapDrillDown.vue'
export default {
  name: 'CenterPanel',
  components: { StatsCard, MapDrillDown }
}
</script>

<style scoped>
.center-panel {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.map-card {
  border-radius: 8px;
  padding: 16px;
  flex: 1;
}
</style>
